import { render } from "./PortfelClient.vue?vue&type=template&id=762af3ab&scoped=true"
import script from "./PortfelClient.vue?vue&type=script&lang=js"
export * from "./PortfelClient.vue?vue&type=script&lang=js"

import "./PortfelClient.vue?vue&type=style&index=0&id=762af3ab&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762af3ab"]])

export default __exports__